import React from "react";

export default function EmptyPage() {
  return <div>Empty Page</div>;
}
